var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-group"},[_c('div',{staticClass:"tab-group-wrapper"},[_c('ul',{staticClass:"tab-group__content"},[_c('li',{staticClass:"tab-item"},[_c('router-link',{attrs:{"to":"/systemSettingOrganizationManageBaseInfo"}},[_vm._v("基础信息")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }